
window.is = function (o) {
    return (o!==null) && (o!==undefined) && (!!o)  && (o!=='0')  && (o!=='')  && (o!=='false');
};

window.printDate = function(d) {
    if (!is(d)) return null;
    d = new Date(d);
    if (isNaN(d.getTime()))  return null;
    let dd = d.getDate();
    let mm = d.getMonth() + 1; //January is 0!
    let yyyy = d.getFullYear();
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    return dd + '.' + mm + '.' + yyyy;
};

window.printDateTime = function(d0, seconds=false, decorated=false, reverse=false) {
    if (!is(d0)) return '--1-'+d0;
    let d = new Date(d0);
    if (isNaN(d.getTime()))  return '--2-'+d0;
    let dd = d.getDate();
    let mm = d.getMonth() + 1; //January is 0!
    let HH = d.getHours();
    let ii = d.getMinutes();
    let ss = d.getSeconds();
    let yyyy = d.getFullYear();
    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    if (HH < 10) HH = '0' + HH;
    if (ii < 10) ii = '0' + ii;
    if (ss < 10) ss = '0' + ss;

    let DDD = dd + '.' + mm + '.' + yyyy;
    let TTT = HH + ':' + ii + (seconds?(':'+ss):'');

    if (reverse) {
        if (decorated)
            return TTT + ' <sup>' + DDD + '</sup>';
        else
            return TTT + ' ' + DDD;
    }
    else {
        if (decorated)
            return DDD + ' <sup>' + TTT + '</sup>';
        else
            return DDD + ' ' + TTT;
    }
};


window.printTimeDate = function(d, seconds=false, decorated=false) {
    return printDateTime(d, seconds, decorated, true);
}



window.isValidDate = function (d) {
    return d instanceof Date && !isNaN(d);
}

/**
 * Convert date from JS object or string to ISO string
 * @param jaDate
 * @returns {*}
 */
window.dateToISO = function (jaDate)
{
    console.log('dateToISO:', jaDate);
    if (!is(jaDate)) { return null; }

    if (isValidDate(jaDate) ) {
        let tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
        return (new Date(jaDate - tzoffset)).toJSON().slice(0, 10);
    }

    if (typeof(jaDate) === 'string') {
        return jaDate.slice(0, 10);
    }

    return null;
}


/**
 * Convert date from JS object or string to ISO string
 * @param jaDate
 * @returns {*}
 */
window.dateTimeToISO = function (jaDate)
{
    console.log('dateToISO:', jaDate);
    if (!is(jaDate)) { return null; }

    if (isValidDate(jaDate) ) {
        let tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
        return (new Date(jaDate - tzoffset)).toJSON().slice(0, 19);
    }

    if (typeof(jaDate) === 'string') {
        return jaDate.slice(0, 10);
    }

    return null;
}

window.rangeString = function (range) {
    if (range !== null)
        return (new Date(range.start).toLocaleDateString()) + '_' + (new Date(range.end).toLocaleDateString())
    return null;
}


window.formatAge = function(y) {
    if (y == 0) return 'до года'
    if ( y==1 ) return y + ' год';
    if ((y>=2) && (y<=4)) return y + ' года';
    if ((y>=5) && (y<=20)) return y + ' лет';
    if ((y%10)==1) return y + ' год';
    if (((y%10)>=2) && ((y%10)<=4)) return y + ' года';
    if (y == 255) return 'взрослый';
    if (y == 254) return 'пожилой';
    return y + ' лет';
}

window.formatNumberRoditelny = function(n) {
    if (n == 0) return 'НОЛЬ';
    if ( n==1 ) return 1 + '-го';
    if ((n>=2) && (n<=4)) return n + '-х';
    if (((n%100)>=5) && ((n%100)<=20)) return n;
    if ((n%10)==1) return n + '-го';
    if (((n%10)>=2) && ((n%10)<=4)) return n + '-х';
    return n ;
}

window.formatPriceKop = function(x, separator=true) {
    let d = (x / 100).toFixed(2);
    let s = d.toString().split(".")
    if (separator) {
        return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, "`") + '.' + s[1];
    }
    else {
        return s[0] + '.' + s[1];
    }
}

window.formatPrice = function(x, separator=true) {
    let d = parseFloat(Math.round(x * 100) / 100).toFixed(2);
    let s = d.toString().split(".")
    if (separator) {
        return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, "`") + '.' + s[1];
    }
    else
    {
        return s[0] + '.' + s[1];
    }
}

window.formatPriceInt = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "`");
}

window.formatGuest = function (guest, age=false) {
    let res = '';
    if (guest.surname) {
        res += guest.surname;
    }
    if (guest.name_) {
        if (res) {
            res += ' ';
        }
        res += guest.name_;
    }
    if (guest.patro) {
        if (res) {
            res += ' ';
        }
        res += guest.patro;
    }

    if (!res) {
        res = '#' + guest.id;
    }

    if (age) {
        if (guest.age==255) {
            if (res) {
                res += ' (взрослый)';
            }
            else {
                res += 'взрослый';
            }
        }
        else {
            if (res) {
                res += ' (' + formatAge(guest.age) + ')';
            }
            else {
                res += formatAge(guest.age);
            }
        }
    }
    return res;
}


window.parseIntDef = function (s, d) {
    let res = parseInt(s);
    if (isNaN(res)) {
        return d;
    }
    return res;
}
